import { Pipe, PipeTransform } from '@angular/core';
import { ApiV1_OptionConfiguration } from '@pedix-workspace/api-v1';
import { OptionConfigurationType } from '@pedix-workspace/utils';

@Pipe({
  name: 'pxwOptionConfigurationsByType',
  standalone: true,
})
export class OptionConfigurationsByTypePipe implements PipeTransform {
  transform(
    value: ApiV1_OptionConfiguration[] | undefined | null,
    optionType: OptionConfigurationType,
  ): ApiV1_OptionConfiguration[] {
    if (!value) {
      return [];
    }
    return value.filter(option => {
      const effectiveType = option.type || 'customization';
      return effectiveType === optionType;
    });
  }
}
